<template>
    <div class="wrap" v-if="translates_loaded">
        <top-header />
        <i-header />
        <router-view class="router-view" id="main-view" />
        <sub-footer />
        <i-footer />
        <back-to-top />
        <i-image-viewer />
    </div>
</template>
<script>
import TopHeader from "./UI/top-header.vue";
import iHeader from "./UI/header.vue";
import iFooter from "./UI/footer.vue";
import SubFooter from "./UI/sub-footer.vue";
import PostView from "./UI/post-view.vue";
import backToTop from "./components/back-to-top.vue";
import iImageViewer from "./components/i-image-viewer.vue";

export default {

    name: 'App',
    components: { iHeader, iFooter, SubFooter, PostView, TopHeader,backToTop,iImageViewer },

    data() {
        return {

            ruhani_logo: require('./assets/img/ruhani/ruhani-logo.svg'),
            ruhani_back: require('./assets/img/ruhani/ruhani-background.svg'),
            ruhani_back2: require('./assets/img/ruhani/mp-citation-bg.jpg'),
            astana_club_logo: require('./assets/img/astana-club.png')

        }
    },
    watch: {
        $route(to) {
            console.log(to);
            //console.log(to)
            if (to.path === '/posts' || to.path === '/events' || to.path === '/multimedia?mode=photo') {
                if (to.hash === "#header") {
                    document.documentElement.scrollTop = 0;
                }
                return;
            }
            document.documentElement.scrollTop = 0;

        }
    },
    computed: {
        translates_loaded() { return this.$store.state.translates_loaded }
    },
    beforeCreate() {

        let self = this;
        this.$store.registerModule('experts', {
            state: {
                list: []
            },
            actions: {
                loadExperts({ state }) {
                    self.$http.get("content/experts").then((res) => {
                        console.log(res.body)
                        state.list = res.body.experts;
                    });
                }
            }
        });
        this.$store.dispatch('loadBackgrounds');
        this.$store.dispatch('loadTranslates');
        this.$store.dispatch('loadVideos');
        this.$store.dispatch('loadAlbums');
        this.$store.dispatch('loadPosts');
        this.$store.dispatch('loadExperts');
    }
}
</script>
<style lang="css">
/*@import "/src/apps/iwep.kz/assets/css/fonts.css";*/

/*COLORING*/

@import "./assets/fonts/k_plumb/index.css";

/*qw*/
@import url('https://fonts.googleapis.com/css?family=Merriweather:300,400,700,900&subset=cyrillic,cyrillic-ext');
* {
    letter-spacing: 1px;
    font-family:  "Plumb", serif;
}

.u-c {
    text-transform: uppercase;
}

.number,
.number * {
    /*font-family: 'Roboto Condensed', sans-serif;*/
}

.logo-image {
    width: 48px;
    /*background: url(./img/logo_white.png);*/
    background-image: url(./assets/img/logo_white.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: inline-block;
    vertical-align: middle;
    line-height: 0;
}


.avatar {
    width: 64px;
    border-radius: 100%;
    border: 1px solid lightgrey;
    background-size: cover;
    background-position: center;
    line-height: 0;
    display: inline-block;
    vertical-align: middle;
}




h2 {
    font-weight: bold;
    color: #1b4877;
}



/*
CARNEGIE COLOR THEME
*/

.header {
    background-color: #105ea0;
}

.footer {
    background-color: #215688;
}

.sub-footer {
    background-color: #105ea0;
}



/*
IWEP COLOR THEME
*/
/*.header,.sub-footer{
  background-color: #18719c;
}
.footer{
  background-color: #135f84;
}*/


/*
.header{
  background: -webkit-linear-gradient(bottom,#0f7dbf,#15c0e0);
}
.sub-footer{
  background-color: #0f7dbf;
}
.footer{
  background: -webkit-linear-gradient(top,#0f7dbf,#15c0e0);
}
*/
@media (min-width: 768px) {
    .container {
        /*max-width: 100%;*/
    }
}

.expert-expanded table {
    border-collapse: collapse;
}

.expert-expanded td {
    border: 1px solid lightgrey;
    padding: 6px;
}

.expert-expanded .content-text,
.expert-expanded .content-text * {
    font-family: 'Merriweather', serif !important;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 1.7;
}

.padding-60 {
    padding: 60px 0;
}

html,body{
    margin:0;
    padding:0;
}
</style>